import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Button, Grid, TextField } from "@mui/material";
import React from "react";

const DatePickerTG = ({ from, to, setFrom, setTo, submitHandle, addition }) => {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container spacing={2} mb={5}>
          <Grid item md={3} sm={12}>
            <h3>С этой даты:</h3>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={from}
              onChange={setFrom}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            <h3>До этой даты:</h3>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={to}
              onChange={setTo}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>{" "}
          <Grid
            item
            xs={3}
            display="flex"
            justifyContent="center"
            alignItems="flex-end"
            pb={1}
          >
            {addition}
          </Grid>
          <Grid
            item
            xs={3}
            display="flex"
            justifyContent="center"
            alignItems="flex-end"
            pb={1}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={() => submitHandle(from, to)}
            >
              получать
            </Button>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </div>
  );
};

export default DatePickerTG;
